
import * as $http from '@/axios'

/**
 * @description c端取消訂單
 * @param {Object} data
 */
export function cancelOrder(data) {
  return $http.post('/order/cancel/normal', data)
}

/**
 * @description c端確認完成訂單
 * @param {Object} data
 */
export function completeOrder(data) {
  return $http.post('/order/complete', data)
}
/**
 * @description c端確認完成訂單
 * @param {Object} data
 */
export function isFirstOrder(data) {
  return $http.post('/account/check/firstOrder', data)
}
/**
 * @description c端申訴
 * @param {Object} data
 */
export function controversyOrder(data) {
  return $http.post('/order/controversy', data)
}

/**
 * @description c端評價
 * @param {Object} data
 */
export function reviewOrder(data) {
  return $http.post('/comment/write', data)
}

/**
 * @description b端拒絕退款
 * @param {Object} data
 */
export function rejectControversy(data) {
  return $http.post('/order/reject/return/player', data)
}

/**
 * @description b端同意退款
 * @param {Object} data
 */
export function confrimControversy(data) {
  return $http.post('/order/accept/return/master', data)
}

/**
 * @description 獲取訂單詳情
 * @param {Object} data
 */
export function orderDetail(data) {
  return $http.get('/order/detail', data)
}

/**
 * @description 獲取評價標籤
 */
export function getCommentTags() {
  return $http.get('/comment/tag/list')
}

/**
 * @description B端提交對C端的評價
 */
export function createCommentToNormal(data) {
  return $http.post('/comment/player/write', data)
}

/**
 * @description B端確認訂單
 */
export function bCompleteOrder(data) {
  return $http.post('/order/playerConfirm', data)
}

/**
 * @description 未支付取消订单
 */
export function cancelPay(data) {
  return $http.post('/order/unpaid/cancel/normal', data)
}


/**
 * @description b端接單
 * @param {Object} data
 */
export function acceptOrder(data) {
  return $http.post('/order/accept/master', data)
}
